import React from 'react';
import '../Auth/auth.css';

interface InputFieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  id: string;
  hideLabel?: boolean; // Ta lastnost bo skrila labelo
  hint?: string;
  error?: string;
  rightElement?: React.ReactNode;
}

const InputField: React.FC<InputFieldProps> = ({
  label,
  id,
  hideLabel, // Uporabimo novo lastnost
  hint,
  error,
  rightElement,
  ...rest
}) => {
  const hintId = hint ? `${id}-hint` : undefined;
  const errorId = error ? `${id}-error` : undefined;
  const describedBy = [hintId, errorId].filter(Boolean).join(' ') || undefined;

  return (
    <div className="form-field">
      <label className={`field-label ${hideLabel ? 'visually-hidden' : ''}`} htmlFor={id}>
        {label}
      </label>
      <div className="field-input-wrapper">
        <input
          className={`field-input${rightElement ? ' field-input-with-action' : ''}`}
          id={id}
          aria-invalid={error ? 'true' : undefined}
          aria-describedby={describedBy}
          {...rest}
        />
        {rightElement && <span className="field-input-action">{rightElement}</span>}
      </div>
      {hint && !error && (
        <p className="field-hint" id={hintId}>
          {hint}
        </p>
      )}
      {error && (
        <p className="status-text error-text" id={errorId} role="alert" aria-live="polite">
          {error}
        </p>
      )}
    </div>
  );
};

export default InputField;
